import { Card, Typography } from "antd";
import { useTranslation } from "react-i18next";
import {
  BellOutlined,
  FileTextOutlined,
  FilePdfFilled,
} from "@ant-design/icons";

const { Text } = Typography;

const getIconByType = (type) => {
  switch (type) {
    case "report":
      return <FileTextOutlined />;
    case "pdf_upload":
      return <FilePdfFilled />;
    default:
      return <BellOutlined />;
  }
};

export default function NotificationItem({
  notification,
  onNotificationClick,
  onMarkAsRead,
}) {
  const { t } = useTranslation("common");
  const { title, messageText, type, is_read: unread } = notification;

  return (
    <Card
      style={{
        background: !unread
          ? "rgba(88, 80, 109, 0.55)" // purple tint
          : "rgba(88, 80, 109, 0.20)",
        borderRadius: 14,
        borderLeft: !unread ? "4px solid #a855f7" : "4px solid transparent",
        borderRadius: 14,
        marginBottom: 16,
        cursor: "pointer",
      }}
      styles={{ padding: "20px 0px 20px 12px" }}
    >
      <div style={{ display: "flex", gap: 14, alignItems: "center" }}
        onClick={() => onMarkAsRead(notification)}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 12,
            background: "#1e40af",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#93c5fd",
            fontSize: 20,
            flexShrink: 0,
          }}
        >
          {getIconByType(type)}
        </div>

        <div>
          <Text
            style={{
              color: "#fff",
              fontSize: 15,
              fontWeight: !unread ? 700 : 500,
              display: "block",
            }}
          >
            {title}
          </Text>
          {messageText && (
            <>
              <Text style={{ color: "#9ca3af", fontSize: 13 }}>
                {messageText}
              </Text>{" "}
              {type === "report" && (
                <Text
                  className="notification-view-report"
                  onClick={() => onNotificationClick(notification)}
                >
                  {t("view_report")}
                </Text>
              )}
              {type === "pdf_upload" && (
                <Text
                  className="notification-view-report"
                  onClick={() => onNotificationClick(notification)}
                >
                  {t("download")}
                </Text>
              )}
            </>
          )}
        </div>
      </div>
    </Card>
  );
}
